module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_fashion-law.077f1505.png";